import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { StringUtil } from "@/core/utils/string_util"

@Serializable
export class LeadResponsibleModel {
  userId: string = ""
  spaceUserId: string = ""
  firstname: string = ""
  lastname: string = ""
  email: string = ""
  roles: string[] = []

  constructor(
    data: {
      userId: string
      spaceUserId: string
      firstname: string
      lastname: string
      email: string
      roles: string[]
    } | null = null,
  ) {
    if (data) {
      this.userId = StringUtil.getSafeString(data.userId)
      this.spaceUserId = StringUtil.getSafeString(data.spaceUserId)
      this.firstname = StringUtil.getSafeString(data.firstname)
      this.lastname = StringUtil.getSafeString(data.lastname)
      this.email = StringUtil.getSafeString(data.email)
      this.roles = data.roles
    }
  }
}
